import { get, post } from "./controller.js";

export function getReportsAPI(params) {
  return get("/api/reports", params);
}

export function addReportAPI(data) {
  return post(`/api/reports/add`, data);
}
